import { render } from "./IndexLama.vue?vue&type=template&id=7334175b"
import script from "./IndexLama.vue?vue&type=script&lang=js"
export * from "./IndexLama.vue?vue&type=script&lang=js"

import "./IndexLama.vue?vue&type=style&index=0&id=7334175b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__